import {fromEvent, merge, of, ReplaySubject, Subject} from "rxjs";
import {ConcatScroll} from "./concat-scroll";
import {delay, filter, map, mergeMap, switchMap, tap, withLatestFrom} from "rxjs/operators";
import {log} from "./test/rxjs-extra-ops";
import lity from 'lity';

const mouseOverSub = new Subject();
const mouseLeaveSub = new Subject();
const mouseSub = new ReplaySubject();
const mouse$ = mouseSub.asObservable();
export const mouseOver$ = mouseOverSub.asObservable();
export const mouseLeave$ = mouseLeaveSub.asObservable();

export const init = (cs: ConcatScroll) => {
   const thumbs = jQuery('.work-thumbnails article');
   thumbs.each(function (index, elem) {

      //console.log(elem);
      const video = getArticleVideo(elem);
      video.oncanplay = function () {
         jQuery(elem).addClass('canplay')
      };

      jQuery(elem).on(
         'mouseover', () => onMouseOver(elem, index));
      jQuery(elem).on(
         'mouseleave', () => onMouseLeave(elem, index));

      jQuery(elem).on(
         'click tap', (event) => onVideoClick(elem, index));



   });

   const onVideoClick = (elem, index) => {

      /*console.log(elem);
      let v = getArticleVideo(elem);
      console.log(v);*/
      let vid = elem.getAttribute('data-vimeo');
      let source = lity(`https://vimeo.com/${vid}`)
   }

   /* mouseOver$.pipe(
       switchMap
    )
 */

   //merge(scroll$)


  /* mouse$.pipe(
      //log('EVENT'),
      switchMap(e => {
         if (isMouseOver(e)) {
            return becauseMouseOver$(e);
         } else {
            return becauseMouseLeave$(e);
         }
      }),
      //log('MOUSE - Yo!')
   ).subscribe();*/

   /*cs.scrollStart$.pipe(
      withLatestFrom
   )*/
   const processVideoEvent = () => {
      return tap( (e: any) => {
         let v = getArticleVideo(e.el);
         if(!v){
            return;
         }
         if( e.action === 'play'){
            jQuery(e.el).addClass('highlight');

            console.log('PLAY VIDEO?', v);
            v.play();

         } else if( e.action === 'pause'){
            console.log('PAUSE VIDEO?', v);
            v.pause();
         } else if( e.action === 'resume'){
            console.log('RESUME VIDEO?', v);
            v.play();

         } else if(e.action === 'stop'){
            //console.log('STOP VIDEO?', v);jQuery(e.el).addClass('highlight');
            v.pause();

            jQuery(e.el).removeClass('highlight');
         }

      })
   }


   merge(
      cs.scrollStart$.pipe(
         withLatestFrom(mouse$),
         filter(([s, m]) => isMouseOver(m)),
         map(([s, m]: [any, {}]) => {
            return {...m, action: 'pause'}
         })
      ),
      cs.scrollStop$.pipe(
         withLatestFrom(mouse$),
         filter(([s, m]) => isMouseOver(m)),
         map(([s, m]: [any, {}]) => {
            return {...m, action: 'resume'}
         })
      ),
      mouse$.pipe(
         //log('EVENT'),
         switchMap(e => {
            if (isMouseOver(e)) {
               return becauseMouseOver$(e);
            } else {
               return becauseMouseLeave$(e);
            }
         }),
         // log('MOUSE - Yo!')
      )
   ).pipe(
      //log('VIDEO EVENT'),
      processVideoEvent()
   ).subscribe()



   const becauseScrollStarted$ = (e) => {
      return of(e).pipe(
         tap()
      )
   }
   const scroll$ = merge(cs.scrollStart$, cs.scrollStop$).pipe(
      //log('scroll')
   );

   const becauseMouseOver$ = (e) => {
      return of(e).pipe(
         delay(300),
         withLatestFrom(scroll$),
         //log('withlatest'),
         filter(([e, s]) => {
            return s['endTime']
            //return {...e, action: 'play', s};
         }),
         map(([e, s]) => {
            return {...e, action: 'play'};
         })
         //tap( e => console.log('MOUSE OVER -after wait', e))
      )
   };

   const becauseMouseLeave$ = (e) => {
      return of(e).pipe(
         //tap( e => console.log('LEAVE -responds immediately', e)),
         map(e => {
            return {...e, action: 'stop'}
         })
      )
   };


   /* merge(scroll$, mouse$).pipe(
       mergeMap( (e: any) => {
          if(isMouseOver(e)){

          } else if( isMouseLeave(e)){

          }
       })
    )*/

};

const isMouseOver = (e) => {
   return e.mouseAction === 'over';
};
const isMouseLeave = (e) => {
   return e.mouseAction === 'leave';
};


const onMouseOver = (el, index) => {
   // console.log('Mouse over', index);
   mouseOverSub.next({el, index, mouseAction: 'over'})
   mouseSub.next({el, index, mouseAction: 'over'})
};
const onMouseLeave = (el, index) => {
   // console.log('Mouse Leave', index);
   mouseLeaveSub.next({el, index, mouseAction: 'leave'})
   mouseSub.next({el, index, mouseAction: 'leave'})
}

const getArticleVideo = (article) => {
   return article.children[0].children[1];
};

